export default "__VITE_ASSET__D4vq$Lnk__"